import React, { useEffect, useState } from "react";
import "./filterModal.css";
import Modal from "@mui/material/Modal";
import axios from "axios";

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: "auto",
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
//   };

const optionst = ["BUY", "SELL", "BANKING"];

const options = [
  "TAM",
  "BILATERAL/DIRECT",
  "REVERSE AUCTION",
  "ANYDAY-REVERSE AUCTION",
  "BANKING",
];

const options2 = [
  "NA",
  "PTC INDIA LTD.",
  "NTPC VIDYUT VYAPAR NIGAM LTD.",
  "ADANI ENTERPRISES LTD.",
  "TATA POWER TRADING COMPANY (P) LTD.",
  "MANIKARAN POWER LTD.",
  "ARUNACHAL PRADESH POWER CORPORATION (P) LTD.",
  "JSW POWER TRADING COMPANY LTD",
  "GMR ENERGY TRADING LTD.",
  "INSTINCT INFRA & POWER LTD.",
  "GREENKO ENERGIES PVT LTD",
  "STATKRAFT MARKETS PVT. LTD.",
  "KREATE ENERGY (I) PVT. LTD.",
  "SHREE CEMENT LTD.",
  "ADARSH STAINLESS PVT. LTD.",
  "RPG POWER TRADING COMPANY LTD.",
  "ALTILIUM ENERGIE PRIVATE LIMITED",
  "KUNDAN INTERNATIONAL PVT. LTD.",
  "AMBITIOUS POWER TRADING COMPANY LTD.",
  "ENERGYEDGE POWER TRADING PVT. LTD.",
  "SARANYU POWER TRADING PRIVATE LIMITED",
  "IDEAL ENERGY SOLUTION PVT. LTD.",
  "ABJA POWER PRIVATE LIMITED",
  "REFEX INDUSTRIES LTD.",
  "REFEX ENERGY LIMITED",
  "NLC INDIA LTD.",
  "SJVN LTD.",
  "POWERFULL ENERGY TRADING PVT. LTD.",
  "INSTANT VENTURES PVT. LTD.",
  "ELSA CONSULTANCY",
  "CUSTOMIZED ENERGY SOLUTIONS INDIA (P) LTD.",
  "SHUBHEKSHA ADVISORS PVT. LTD.",
  "GITA POWER & INFRASTRUCTURE PRIVATE LIMITED",
  "SAINI POWER TRANSACTOR",
  "NEFA POWER TRADING PVT. LTD.",
  "PHILLIP COMMODITIES INDIA (P) LTD.",
  "REL POWER TRADING LLP",
  "SHELL ENERGY MARKETING AND TRADING INDIA PVT. LTD.",
  "RENESYS SOLAR PVT. LTD.",
  "RENEURJA POWER LLP",
  "OTHER",
];

const bilateraloptions = [
  "NA",
  "PTC INDIA LTD.",
  "NTPC VIDYUT VYAPAR NIGAM LTD.",
  "ADANI ENTERPRISES LTD.",
  "TATA POWER TRADING COMPANY (P) LTD.",
  "MANIKARAN POWER LTD.",
  "ARUNACHAL PRADESH POWER CORPORATION (P) LTD.",
  "JSW POWER TRADING COMPANY LTD",
  "GMR ENERGY TRADING LTD.",
  "INSTINCT INFRA & POWER LTD.",
  "GREENKO ENERGIES PVT LTD",
  "STATKRAFT MARKETS PVT. LTD.",
  "KREATE ENERGY (I) PVT. LTD.",
  "SHREE CEMENT LTD.",
  "ADARSH STAINLESS PVT. LTD.",
  "RPG POWER TRADING COMPANY LTD.",
  "ALTILIUM ENERGIE PRIVATE LIMITED",
  "KUNDAN INTERNATIONAL PVT. LTD.",
  "AMBITIOUS POWER TRADING COMPANY LTD.",
  "ENERGYEDGE POWER TRADING PVT. LTD.",
  "SARANYU POWER TRADING PRIVATE LIMITED",
  "IDEAL ENERGY SOLUTION PVT. LTD.",
  "ABJA POWER PRIVATE LIMITED",
  "REFEX INDUSTRIES LTD.",
  "REFEX ENERGY LIMITED",
  "NLC INDIA LTD.",
  "SJVN LTD.",
  "POWERFULL ENERGY TRADING PVT. LTD.",
  "INSTANT VENTURES PVT. LTD.",
  "ELSA CONSULTANCY",
  "CUSTOMIZED ENERGY SOLUTIONS INDIA (P) LTD.",
  "SHUBHEKSHA ADVISORS PVT. LTD.",
  "GITA POWER & INFRASTRUCTURE PRIVATE LIMITED",
  "SAINI POWER TRANSACTOR",
  "NEFA POWER TRADING PVT. LTD.",
  "PHILLIP COMMODITIES INDIA (P) LTD.",
  "REL POWER TRADING LLP",
  "SHELL ENERGY MARKETING AND TRADING INDIA PVT. LTD.",
  "RENESYS SOLAR PVT. LTD.",
  "RENEURJA POWER LLP",
  "OTHER",
];

const FilterModal = ({
  open,
  handleClose,
  setTotalList,
  setTableData,
  setFilterData,
}) => {
  const editId = localStorage.getItem("procurement_edit_id");

  const initialState = {
    type_of_transaction: null,
    purchase_through_product: null,
    trader_bidder: null,
    name_of_counterparty_generator: null,
    drawal_purchase_import_date_from: null,
    drawal_purchase_import_date_to: null,
    drawal_purchase_import_time_from: null,
    drawal_purchase_import_time_to: null,
    inject_sell_export_date_from: null,
    inject_sell_export_date_to: null,
    inject_sell_export_time_from: null,
    inject_sell_export_time_to: null,
    ppa_date_agreement_date: null,
    loi_number: null,
    loi_date: null,
  };
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    let payload = {
      page: 1,
      per_page: 50,
      filter: formData,
    };
    const data = await axios.post(
      "https://datahub.gna.energy/rajasthan_procurement",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (data?.data?.total > 0) {
      setTableData(data?.data?.data);
      setTotalList(data?.data?.total);
      setFilterData(formData);
      handleClose();
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="filter-main-modal">
        <form className="form-filter" id="procurement-form">
          <div className="form-section-filter">
            <div className="form-section-sub-filter">
              <div className="form-dropdown-filter">
                <label className="block-head-filter">
                  Types of Transaction
                </label>
                <select
                  name="type_of_transaction"
                  value={
                    formData?.type_of_transaction === "PURCHASE"
                      ? "BUY"
                      : formData?.type_of_transaction
                  }
                  onChange={handleChange}
                  className="select-option-filter"
                >
                  <option value="">-- Select an Option --</option>
                  {optionst.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-dropdown-filter">
                <label className="block-head-filter">
                  Purchase through / Product
                </label>
                <select
                  name="purchase_through_product"
                  value={formData?.purchase_through_product}
                  onChange={handleChange}
                  className="select-option-filter"
                >
                  <option value="">-- Select an Option --</option>
                  {options.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-dropdown-filter">
                <label className="block-head-filter">Trader/ Bidder</label>
                <select
                  name="trader_bidder"
                  value={formData?.trader_bidder}
                  onChange={handleChange}
                  className="select-option-filter"
                >
                  <option value="">-- Select an Option --</option>
                  {(formData?.purchase_through_product === "BILATERAL/DIRECT"
                    ? bilateraloptions
                    : options2
                  )?.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="datetime-filter">
                <label className="blockhead-filter">
                  Name of Counterparty / Generator
                </label>
                <input
                  type="text"
                  className="field1-filter"
                  name="name_of_counterparty_generator"
                  onChange={handleChange}
                  value={formData?.name_of_counterparty_generator}
                />
              </div>
            </div>
          </div>

          {/* drawl section */}
          {(formData?.type_of_transaction === "PURCHASE" ||
            formData?.type_of_transaction === "BUY" ||
            formData?.type_of_transaction === "BANKING") && (
            <div className="drawal-section-filter">
              <h2 className="drawal-heading-filter">
                Drawl / Purchase / Buy / Import
              </h2>
              <div className="drawal-fields-filter">
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">From Date:</label>
                  <input
                    type="date"
                    name="drawal_purchase_import_date_from"
                    value={formData?.drawal_purchase_import_date_from}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">To Date:</label>
                  <input
                    type="date"
                    name="drawal_purchase_import_date_to"
                    value={formData?.drawal_purchase_import_date_to}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">From Time:</label>
                  <input
                    type="time"
                    name="drawal_purchase_import_time_from"
                    value={formData?.drawal_purchase_import_time_from}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">To Time:</label>
                  <input
                    type="time"
                    name="drawal_purchase_import_time_to"
                    value={formData?.drawal_purchase_import_time_to}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
              </div>
            </div>
          )}

          {(formData?.type_of_transaction === "SELL" ||
            formData?.type_of_transaction === "BANKING") && (
            <div className="drawal-section-filter">
              <h2 className="drawal-heading-filter">
                {" "}
                Inject / Sell / Export{" "}
              </h2>
              <div className="drawal-fields-filter">
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">From Date:</label>
                  <input
                    type="date"
                    name="inject_sell_export_date_from"
                    value={formData?.inject_sell_export_date_from}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">To Date:</label>
                  <input
                    type="date"
                    name="inject_sell_export_date_to"
                    value={formData?.inject_sell_export_date_to}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">From Time:</label>
                  <input
                    type="time"
                    name="inject_sell_export_time_from"
                    value={formData?.inject_sell_export_time_from}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
                <div className="field-group-filter">
                  <label className="drawalblockhead-filter">To Time:</label>
                  <input
                    type="time"
                    name="inject_sell_export_time_to"
                    value={formData?.inject_sell_export_time_to}
                    onChange={handleChange}
                    className="drawalfield1-filter"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="form-section-filter">
            <div className="form-section-sub-filter">
              <div className="datetime-filter">
                <label className="blockhead-filter">
                  PPA Date/ Agreement Date
                </label>
                <input
                  type="date"
                  className="field1-filter"
                  name="ppa_date_agreement_date_loi_date"
                  value={formData?.ppa_date_agreement_date}
                  onChange={handleChange}
                />
              </div>

              <div className="datetime-filter">
                <label className="blockhead-filter">LOI Date</label>
                <input
                  type="date"
                  className="field1-filter"
                  name="loi_date"
                  value={formData?.loi_date}
                  onChange={handleChange}
                />
              </div>

              <div className="datetime-filter">
                <label className="blockhead-filter">LOI No.</label>
                <input
                  type="text"
                  className="field1-filter"
                  name="loi_number"
                  value={formData?.loi_number}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="button-filter">
            <div onClick={handleSubmit} className="submitButton">
              Submit
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default FilterModal;
